import {FieldProps} from 'formik';
import {DateTimePicker, DateTimePickerProps} from '@mantine/dates';

export const TimestampInput = ({
                                   field,
                                   form,
                                   ...rest
                               }: FieldProps & DateTimePickerProps) => {

    const dateValue = field.value ? new Date(field.value * 1000) : null;

    return (
        <DateTimePicker
            {...rest}
            value={dateValue}
            onChange={(value: string | null) => {
                // Mantine 8 hands back a local date string ("YYYY-MM-DD HH:mm:ss")
                // instead of a Date; parse it back before converting to epoch seconds.
                const parsed = value ? new Date(value) : null;
                const timestamp = parsed && !isNaN(parsed.getTime())
                    ? Math.floor(parsed.getTime() / 1000)
                    : undefined;
                form.setFieldValue(field.name, timestamp);
            }}
            onBlur={() => form.setFieldTouched(field.name, true)}
            error={form.touched[field.name] && form.errors[field.name] ? form.errors[field.name] as string : undefined}
        />
    );
};
